import React from 'react';

const CustomerReportPage = React.lazy(() => import('pages/CustomerReport/CustomerReportPage'));

const CustomerReportRoute = [
  {
    path: '/customer-report',
    exact: true,
    name: 'Báo cáo khách hàng',
    component: CustomerReportPage,
  },
];

export default CustomerReportRoute;
